import Steps from './Steps';
import Step from './Step';
Steps.Step = Step;
export { Step };
export default Steps;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-steps@3.5.0@rc-steps/es/index.js
// module id = 1376
// module chunks = 0